import { colors } from 'theme/colors';

export enum ScoreBand {
  Poor = 'poor',
  Fair = 'fair',
  Good = 'good',
  Strong = 'strong',
}

/** Whole numbers, like the legacy module: the server keeps two decimals, the screen shows none. */
const shownPercentage = (percentage: number): number => Math.round(percentage);

/** Contiguous, unlike the legacy `<=49 / >50` pair whose gap rendered exactly 50% as green. Bands the
 *  rounded number the screen shows, so 49.4% cannot read "49%" in a different colour from 49%. */
export const scoreBand = (percentage: number): ScoreBand => {
  const shown = shownPercentage(percentage);
  if (shown <= 49) {
    return ScoreBand.Poor;
  }
  if (shown <= 69) {
    return ScoreBand.Fair;
  }
  if (shown <= 89) {
    return ScoreBand.Good;
  }
  return ScoreBand.Strong;
};

export const scoreBandColor = (percentage: number): string => colors.ui.score[scoreBand(percentage)];

export const formatScorePercentage = (percentage: number): string => `${shownPercentage(percentage)}%`;
